export const PointsGoldLarge = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="52"
      viewBox="0 0 53 52"
      width="53"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_163_12248)">
        <path
          d="M26.5025 52.0004C40.8609 52.0004 52.5006 40.3606 52.5006 26.0023C52.5006 11.6439 40.8609 0.00415039 26.5025 0.00415039C12.1441 0.00415039 0.504395 11.6439 0.504395 26.0023C0.504395 40.3606 12.1441 52.0004 26.5025 52.0004Z"
          fill="#FFE876"
        />
        <path
          d="M40.3502 3.99717C28.2 -3.65133 12.1464 -0.000228611 4.4979 12.15C-3.1506 24.3041 0.500504 40.3539 12.6508 48.0024L40.3502 3.99717Z"
          fill="white"
          opacity="0.4"
        />
        <path
          d="M41.1816 40.6804C49.2884 32.5736 49.2884 19.43 41.1816 11.3233C33.0749 3.21655 19.9313 3.21655 11.8245 11.3233C3.71781 19.43 3.71781 32.5736 11.8245 40.6804C19.9313 48.7871 33.0749 48.7871 41.1816 40.6804Z"
          fill="#E6B54A"
        />
        <path
          d="M7.92239 26.0027C7.92239 14.9026 16.6323 5.83886 27.5894 5.27425C27.2281 5.25543 26.8667 5.24414 26.4979 5.24414C15.0326 5.24414 5.73926 14.5375 5.73926 26.0027C5.73926 37.468 15.0326 46.7613 26.4979 46.7613C26.863 46.7613 27.2281 46.75 27.5894 46.7312C16.6323 46.1629 7.92239 37.0991 7.92239 26.0027Z"
          fill="#D19828"
        />
        <path
          clip-rule="evenodd"
          d="M17.5227 25.5658C17.5227 27.9336 17.7032 31.8998 22.3609 31.8998L22.9682 28.6384C21.2086 28.6384 20.8116 28.0146 20.8116 25.554L20.7137 13.668L17.4248 13.6948L17.5227 25.5658ZM35.883 30.9339V19.3502H32.5941V26.3194C32.4884 27.9827 31.3686 28.8084 30.0334 28.8084C28.5378 28.8084 27.6607 27.8405 27.6607 26.0744V19.3502H24.3836V27.1333L24.3875 27.3229C24.4732 30.0569 26.4195 31.8979 29.1172 31.8979C30.4367 31.8979 31.7288 31.4752 32.5941 30.2742V30.9379C32.5976 32.5024 31.9755 33.743 30.8478 34.4265C29.6536 35.1495 28.1071 35.1337 26.7054 34.383L25.1627 37.3145C26.3643 37.9585 27.649 38.2789 28.9019 38.2789C30.1818 38.2789 31.4351 37.9427 32.5432 37.271C34.6692 35.9791 35.8869 33.6679 35.883 30.9339Z"
          fill="#FFF1AD"
          fill-rule="evenodd"
        />
        <path
          clip-rule="evenodd"
          d="M21.3208 31.9305C21.6478 31.9819 22.0031 32.0091 22.3892 32.0091L22.8707 29.4231L21.3208 31.9305ZM24.4118 26.9298V27.2426L24.4157 27.4322C24.5015 30.1662 26.4478 32.0073 29.1455 32.0073C30.465 32.0073 31.757 31.5845 32.6223 30.3835V31.0472C32.6259 32.6117 32.0037 33.8523 30.8761 34.5358C29.6819 35.2588 28.1353 35.243 26.7336 34.4923L25.191 37.4238C26.3926 38.0678 27.6772 38.3882 28.9301 38.3882C30.2101 38.3882 31.4634 38.052 32.5714 37.3804C34.6975 36.0884 35.9152 33.7772 35.9112 31.0433V19.4595H32.6223V26.4287C32.5166 28.092 31.3968 28.9177 30.0617 28.9177C28.566 28.9177 27.689 27.9498 27.689 26.1838V21.6279L24.4118 26.9298Z"
          fill="#FFE876"
          fill-rule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_163_12248">
          <rect fill="white" height="52" transform="translate(0.5)" width="52" />
        </clipPath>
      </defs>
    </svg>
  );
};
